import { Check } from 'lucide-react';

/** The journey's steps. Done: solid blue with a check; current: light blue with a blue ring; to come: grey. */
const Stepper = ({ labels, current }: { labels: string[]; current: number }) => (
  <ol className="flex w-full" aria-label="Progress">
    {labels.map((label, index) => {
      const step = index + 1;
      const state = step < current ? 'done' : step === current ? 'current' : 'todo';
      return (
        <li key={label} className="relative flex-1 flex flex-col items-center gap-2 min-w-0" aria-current={state === 'current' ? 'step' : undefined}>
          {index < labels.length - 1 && (
            // From this circle's centre to the next one's, behind both circles.
            <span
              aria-hidden
              className={`absolute left-1/2 w-full top-3.5 md:top-4 h-px ${step < current ? 'bg-lend-blue-dark' : 'bg-gray-300'}`}
            />
          )}
          <span
            className={`relative z-10 h-7 w-7 md:h-8 md:w-8 rounded-full flex items-center justify-center ${
              state === 'done'
                ? 'bg-lend-blue-dark text-white'
                : state === 'current'
                  ? 'bg-lend-blue-soft border-2 border-lend-blue-dark'
                  : 'bg-gray-100 border border-gray-300'
            }`}
          >
            {state === 'done' && <Check className="h-4 w-4" strokeWidth={3} aria-hidden />}
          </span>
          <span className={`text-xs md:text-sm text-center leading-tight px-1 ${state === 'current' ? 'text-lend-blue-dark' : 'text-lend-muted'}`}>
            {label}
          </span>
        </li>
      );
    })}
  </ol>
);

export default Stepper;
